import { FileNumberUtil } from './../../shared/file-number-util';
import { Pleading } from './pleading';
import { Issue } from './issue';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';

export class TransferAndAppeals {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getAppealClockDate(): string {
        return SafeJSON.get('appealDate', this.json);
    }
    getAppealedToCase(civilCase: CivilCase): string {
        const paidIndicator = this.getPaidIndicator();
        if (paidIndicator === 'Y') {
            const fileNumber = civilCase.getAppealToFormattedShortFileNumber();
            return civilCase.getCourtTypeName(fileNumber) + 'x ' + fileNumber;
        }
        return '-';
    }
    getAppealedToCourt(): string {
        return SafeJSON.get('appealToCourtCode.description', this.json);
    }
    getAppealedByPartyRefList(): any [] {
        let partyRefList: any [];
        partyRefList = SafeJSON.get('partyRefs', this.json);
        if (partyRefList === undefined || partyRefList.length === 0) {
            return [];
        }
        partyRefList = Array.from(partyRefList.values());
        return partyRefList;
    }
    getPaidIndicator(): string {
        return SafeJSON.get('paidInd', this.json);
    }
    getReturnDate(): string {
        return SafeJSON.get('returnDate', this.json);
    }
    getResultReturnedByCourt(): string {
        return SafeJSON.getWithDefault('appealResultCode.description', this.json);
    }
    getAppealedIssueClockDate(civilCase: CivilCase): string {
        const issueKey = SafeJSON.getWithDefault('appealedIssueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueKey);
        const pleadingKey = issue.getPleadingKey();
        const pleading: Pleading = civilCase.getPleadingByKey(pleadingKey);
        return pleading.getClockDate();
    }
    getAppealedPleadingType(civilCase: CivilCase): string {
        const issueKey = SafeJSON.getWithDefault('appealedIssueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueKey);
        const pleadingKey = issue.getPleadingKey();
        const pleading: Pleading = civilCase.getPleadingByKey(pleadingKey);
        const description = pleading.getPleadingTypeDescription();
        return description;
    }
    getAppealedIssueType(civilCase: CivilCase): string {
        const issueKey = SafeJSON.getWithDefault('appealedIssueRef', this.json);
        const issue: Issue = civilCase.getIssueListByKey(issueKey);
        const issueType = issue.getTypeReplaceOther();
        return issueType;
    }
}




// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/transferAndAppeals.ts